const dataRequestForm = {
  title: "Búa til gagnabeiðni",
  errors: {
    loadProjectsFailed: "Ekki tókst að hlaða verkefnum",
    loadDatasetsFailed: "Ekki tókst að hlaða gagnasöfnum",
    selectDatasetRequired: "Vinsamlegast veldu gagnasafn",
    selectColumnRequired:
      "Veldu að minnsta kosti einn dálk, eða hreinsaðu dálkaval til að óska eftir allri skránni",
    createFailed: "Ekki tókst að búa til gagnabeiðni",
  },
  success: {
    createdAndForwarded: "Gagnabeiðni var búin til og framsend!",
    createdForwardFailed:
      "Gagnabeiðni var búin til, en ekki tókst að framsenda hana. Þú getur framsent hana handvirkt af nánari upplýsingum beiðninnar.",
    created: "Gagnabeiðni var búin til!",
  },
  fields: {
    project: {
      label: "Verkefni *",
      placeholder: "Veldu verkefni",
    },
    sourceType: {
      label: "Tegund gagnauppsprettu *",
      upload: "Óska eftir nýju gagnasafni",
      dataset: "Velja úr fyrirliggjandi gagnasöfnum",
    },
    title: {
      label: "Titill beiðni *",
      placeholder: "t.d. Sjúklingagögn fyrir hjarta- og æðarannsókn",
    },
    description: {
      label: "Lýsing *",
      defaultText: "Beiðni um gögn úr {{datasetName}}",
    },
    requestedFields: {
      label: "Umbeðnir reitir (valkvætt)",
      placeholder: "kennitala, first_name, last_name\neða einn á línu",
      hint: "Skildu eftir autt til að óska eftir öllum reitum skrárinnar.",
    },
    processingNotes: {
      label: "Athugasemdir til gagnaveitanda (valkvætt)",
      placeholderDataset:
        "Allt sem yfirferðaraðili ætti að vita — t.d. aðeins fullorðnir, eða að aldursdálkurinn sé með blönduðum einingum",
      placeholderUpload:
        "Síunarskilyrði í eigin orðum, eða gagnagæðavandamál sem ber að hafa í huga",
    },
  },
  dataset: {
    sectionTitleLocked: "Gagnasafn",
    sectionTitle: "Veldu gagnasafn *",
    loading: "Hleð gagnasöfnum…",
    searchPlaceholder: "Leita að gagnasöfnum eftir nafni…",
    selectedPlaceholder: "Valið: {{name}}",
    noneAvailable: "Engin gagnasöfn í boði til að óska eftir",
    noMatch: "Engin gagnasöfn samsvara leitinni",
    rows: "raðir",
    rowsUnknown: "Óþekkt",
    columns: "dálkar",
    clear: "Hreinsa",
    browseCatalog: "Skoða heildaryfirlit →",
    browseCatalogHint: "til að skoða gagnasöfn með síum",
  },
  advanced: {
    toggle: "Ítarlegri valkostir",
    hint: "þrengja að tilteknum dálkum eða gildissviðum",
    selectDatasetNote: "Veldu gagnasafn hér að ofan til að velja dálka og síur.",
    noColumnMetadata:
      "Þetta gagnasafn hefur engin lýsigögn um dálka, svo aðeins er hægt að óska eftir því í heild.",
  },
  columns: {
    label: "Dálkar",
    countAll: "allir {{count}}",
    countSelected: "{{selected}} af {{total}}",
    countFiltered: " · {{count}} síaðir",
    selectAll: "Velja allt",
    clear: "Hreinsa",
    clearFilters: "Hreinsa síur",
    headerColumn: "Dálkur",
    headerType: "Tegund",
    headerFilter: "Sía",
    includeAria: "Hafa með {{column}}",
    personalData: "Persónuupplýsingar",
    personalDataTitle: "Persónuupplýsingar — gildin eru dulnefnd",
    identifier: "Auðkenni",
    identifierTitle: "Auðkennisdálkur — verður dulnefndur",
    notFilterable: "Ekki hægt að sía",
    notFilterableTitle:
      "Dálkar með persónuupplýsingum eru dulnefndir, svo ekki er hægt að sía eftir upprunalegum gildum þeirra",
    minAria: "Lágmark {{column}}",
    maxAria: "Hámark {{column}}",
    rangeTitle: "Bil {{min}} – {{max}}",
    categoriesAria: "Flokkar fyrir {{column}}",
  },
  redirect: {
    toggle: "Framsenda til gagnaveitanda við stofnun (valkvætt)",
    description:
      "Veldu gagnaveitendur til að framsenda þessa beiðni til strax eftir stofnun:",
    dataProviders: "Gagnaveitendur",
    organizations: "Stofnanir",
    notesLabel: "Athugasemd við framsendingu (valkvætt)",
    notesPlaceholder: "t.d. „Sjúklingaskrár fyrir rannsókn á 4. ársfjórðungi“",
    defaultNote: "Beiðni stofnuð og framsend til gagnaveitanda",
  },
  submit: {
    submitting: "Sendi beiðni...",
    submit: "Senda gagnabeiðni",
  },
};

export default dataRequestForm;
